import dayjs from "dayjs";

interface BookingPositionInput {
  timelineStart: string; // ISO string, es. "2025-06-20T00:00:00"
  timelineDays: number;  // es. 15
  checkIn: string;       // ISO string, es. "2025-06-27T15:00:00"
  checkOut: string;      // ISO string, es. "2025-06-30T10:00:00"
}

interface BookingPositionOutput {
  marginLeft: number;
  width: number;
}

export function getBookingSegmentPosition({
  timelineStart,
  timelineDays,
  checkIn,
  checkOut
}: BookingPositionInput): BookingPositionOutput {
  const timelineStartTime = dayjs(timelineStart);
  const timelineEndTime = timelineStartTime.add(timelineDays, 'day');
  const totalTimelineHours = timelineEndTime.diff(timelineStartTime, 'hour');

  const checkInTime = dayjs(checkIn);
  const checkOutTime = dayjs(checkOut);

  // Early exit if the booking is entirely outside the timeline
  if (checkOutTime.isBefore(timelineStartTime) || checkInTime.isAfter(timelineEndTime)) {
    return { marginLeft: 0, width: 0};
  }

  // Clamp booking within the timeline bounds
  const clampedCheckIn = checkInTime;
  const clampedCheckOut = checkOutTime;
  /* const clampedCheckIn = checkInTime.isBefore(timelineStartTime)
    ? timelineStartTime
    : checkInTime;
  const clampedCheckOut = checkOutTime.isAfter(timelineEndTime)
    ? timelineEndTime
    : checkOutTime; */

  const startHourOffset = clampedCheckIn.diff(timelineStartTime, 'hour', true); // true = float
  const bookingHours = clampedCheckOut.diff(clampedCheckIn, 'hour', true);

  const marginLeft = (startHourOffset / totalTimelineHours) * 100;
  const width = (bookingHours / totalTimelineHours) * 100;

  return {
    marginLeft,
    width
  };
}